<template>
  <n-layout>
    <n-layout-header
      class="flex h-[50px] items-center pl-5 pr-[30px] justify-between border-b-gray-border border-b"
    >
      <div class="flex items-center">
        <img src="/logo.png" width="40" />
        <span
          class="mx-[10px] text-black font-bold text-base whitespace-nowrap"
          >{{ $t('deviationWritingSystem') }}</span
        >
        <el-select
          v-model="dialogStore.globalModel"
          class="w-28"
          v-if="dialogStore.debug"
          size="small"
        >
          <el-option
            v-for="model in (['q2_7b' , 'q2_72b' , 'q1half_14b' , 'q1half_32b' , 'm4_9b'] as Model[])"
            :key="model"
            :label="model"
            :value="model"
          />
        </el-select>
      </div>
      <n-dropdown
        trigger="hover"
        :options="options"
        @select="handleSelect"
        class="w-60"
      >
        <n-avatar round color="#BDC3CE">
          <svg-icon name="user-avatar" width="22" height="22" />
        </n-avatar>
      </n-dropdown>
    </n-layout-header>
    <n-layout has-sider style="height: calc(100vh - 50px)">
      <n-layout-sider
        class="bg-[#FBFBFA] border-r border-r-gray-border"
        :width="locale === 'zh-cn' ? '220px' : '250px'"
        v-show="!hideSidebar"
      >
        <div class="px-1 pt-3">
          <el-menu :default-active="defaultActiveMenu">
            <Authority :permission="DIALOG">
              <el-sub-menu index="1">
                <template #title>
                  <div class="flex items-center">
                    <svg-icon name="nav-dialog" class="mr-[9px]" />
                    <span>{{ $t('nav.deviationWriting') }}</span>
                  </div>
                </template>
                <router-link :to="{ name: 'dialog' }" v-slot="{ isActive }">
                  <el-menu-item index="1-1">
                    <div
                      class="router-link"
                      :class="{
                        'is-active': isActive
                      }"
                    >
                      <span class="ml-[10px]"
                        >{{ $t('nav.deviationConversation') }}
                      </span>
                    </div>
                  </el-menu-item>
                </router-link>
                <router-link :to="{ name: 'history' }" v-slot="{ isActive }">
                  <el-menu-item index="1-2">
                    <div
                      class="router-link"
                      :class="{
                        'is-active': isActive
                      }"
                    >
                      <span class="ml-[10px]">{{
                        $t('nav.historyRecord')
                      }}</span>
                    </div>
                  </el-menu-item>
                </router-link>
              </el-sub-menu>
            </Authority>
            <Authority :permission="EVALUATION">
              <router-link :to="{ name: 'audit' }" v-slot="{ isActive }">
                <el-menu-item index="2">
                  <div
                    class="router-link"
                    :class="{
                      'is-active': isActive
                    }"
                  >
                    <svg-icon name="nav-audit" class="mr-[10px]" />
                    <span>{{ $t('nav.deviationReportApproval') }}</span>
                  </div>
                </el-menu-item>
              </router-link>
            </Authority>
            <Authority :permission="AGENT">
              <el-sub-menu index="3">
                <template #title>
                  <div class="flex items-center">
                    <svg-icon
                      name="nav-setting"
                      class="mr-[9px]"
                      width="14"
                      height="14"
                    />
                    <span>{{ $t('nav.deviationAssistantSetting') }}</span>
                  </div>
                </template>
                <router-link
                  :to="{ name: 'estimate-standard' }"
                  v-slot="{ isActive }"
                >
                  <el-menu-item index="3-1">
                    <div
                      class="router-link"
                      :class="{
                        'is-active': isActive
                      }"
                    >
                      <span class="ml-[10px]"
                        >{{ $t('nav.assessmentCriteria') }}
                      </span>
                    </div>
                  </el-menu-item>
                </router-link>
                <router-link
                  :to="{ name: 'factor-problem' }"
                  v-slot="{ isActive }"
                >
                  <el-menu-item index="3-2">
                    <div
                      class="router-link"
                      :class="{
                        'is-active': isActive
                      }"
                    >
                      <span class="ml-[10px]">{{
                        $t('nav.elementFactors')
                      }}</span>
                    </div>
                  </el-menu-item>
                </router-link>
              </el-sub-menu>
            </Authority>
            <Authority :permission="SETTINGS">
              <router-link
                :to="{ name: 'system-setting' }"
                v-slot="{ isActive }"
              >
                <el-menu-item index="4">
                  <div
                    class="router-link"
                    :class="{
                      'is-active': isActive
                    }"
                  >
                    <svg-icon
                      name="nav-system-setting"
                      class="mr-[10px]"
                      width="14"
                      height="13"
                    />
                    <span>{{ $t('nav.systemSetting') }}</span>
                  </div>
                </el-menu-item>
              </router-link>
            </Authority>
          </el-menu>
        </div>
      </n-layout-sider>
      <n-layout-content>
        <router-view v-slot="{ Component, route }">
          <keep-alive>
            <component
              :is="Component"
              v-if="route.meta.keepAlive"
              :class="[
                collapse && !['audit-detail'].includes(String(route.name))
                  ? 'px-[170px]'
                  : 'px-[60px]'
              ]"
            />
          </keep-alive>
          <component
            :is="Component"
            v-if="!route.meta.keepAlive"
            :class="[
              collapse && !['audit-detail'].includes(String(route.name))
                ? 'px-[170px]'
                : 'px-[60px]'
            ]"
          />
        </router-view>
        <svg-icon
          name="nav-collapse"
          width="40"
          height="40"
          v-show="!['audit-detail'].includes(String(route.name))"
          @click="collapse = !collapse"
          class="fixed cursor-pointer left-6 bottom-[55px] z-10"
          :class="[collapse ? '' : 'rotate-180']"
        />
      </n-layout-content>
    </n-layout>
  </n-layout>
</template>

<script setup lang="ts">
import { h } from 'vue'
import SvgIcon from '@/components/svg-icon/SvgIcon.vue'
import { useDialogStore, useLoginStore } from '@/store'
import { DIALOG, SETTINGS, AGENT, EVALUATION } from '@/router'
import { NAvatar, NText } from 'naive-ui'
import { type Model } from '@/service'

const loginStore = useLoginStore()
const dialogStore = useDialogStore()
const route = useRoute()
const collapse = ref(false)
const hideSidebar = computed(() => {
  if (collapse.value) return true
  if (typeof route.name === 'string')
    return ['audit-detail'].includes(route.name)
  return false
})
const defaultActiveMenu = computed(() => {
  switch (route.name) {
    case 'dialog':
      return '1-1'
    case 'history':
      return '1-2'
    case 'estimate-standard':
      return '3-1'
    case 'factor-problem':
      return '3-2'
    default:
      return undefined
  }
})

const { t, locale } = useI18n()
function renderCustomHeader() {
  return h(
    'div',
    {
      style: 'display: flex; align-items: center; padding: 14px 17px 13px;'
    },
    [
      h(
        NAvatar,
        {
          round: true,
          color: '#BDC3CE',
          style: {
            marginRight: '10px'
          },
          size: 38
        },
        [h(SvgIcon, { name: 'user-avatar', width: '38', height: '38' })]
      ),
      h('div', null, [
        h('div', { style: 'font-size: 12px;' }, [
          h(
            NText,
            { depth: 2, style: { color: '#646973' } },
            {
              default: () => `${t('account')}：${loginStore.userInfo?.account}`
            }
          )
        ]),
        h('div', { style: 'font-size: 12px;' }, [
          h(
            NText,
            { depth: 2, style: { color: '#646973' } },
            { default: () => `${t('mail')}：${loginStore.userInfo?.email}` }
          )
        ])
      ])
    ]
  )
}
const options = computed(() => {
  return [
    {
      key: 'header',
      type: 'render',
      render: renderCustomHeader
    },
    {
      key: 'header-divider',
      type: 'divider'
    },
    {
      label: t('login.logout'),
      icon() {
        return h(SvgIcon, {
          name: 'user-loginout',
          style: {
            color: '#BDC3CE',
            fontSize: '14px'
          }
        })
      },
      key: 'login-out',
      props: {
        onClick() {
          dialogStore.resetDialog()
          loginStore.loginOut()
        }
      }
    }
  ]
})
const handleSelect = (key: string) => {
  console.log(key)
}
</script>

<style lang="scss" scoped>
.router-link {
  transition: color 0.3s var(--n-bezier);
  @apply text-sm flex items-center;
}
.router-link:hover,
.router-link.is-active {
  @apply text-primary;
}
:deep(.el-sub-menu.is-active > .el-sub-menu__title) {
  @apply text-primary bg-router-active;
}
</style>
